<template>
    <div style="position: relative;">
        <div class="descAlert" v-show="['shtd_qy'].indexOf(currentPage)==-1">
            <p v-for="(item,index) in DescList" :key="index">{{item.desc}}</p>
            <a :href="DescLink" target="_blank" style="padding-left:5px;" v-show="currentPage=='yhfzxz_qy'"> >点击此处查看工商业客户用水报装服务指南</a>
        </div>
        <div style="padding:20px 20%">
            <div style="margin-top:30px">
                <Divider style="color:#888;font-size:12px;">请选择用于此次操作的角色</Divider>
                <SelectRole @currentRoleData="CurrentRoleData" ref="RoleForm"></SelectRole>
            </div>

            <Divider style="color:#888;font-size:12px;">以下内容请准确填写</Divider>

            <Form ref="FormValidate" :model="FormValidate" :rules="RuleValidate" :label-width="124">
                <FormItem label="客户编号" prop="S_CID" v-if="currentPage!='yhfzxz_qy'">
                    <Select v-model="FormValidate.S_CID"
                            filterable
                            allow-create
                            @on-select="ScidBlur"
                            :disabled="FormValidate.BtnName=='提交'"
                            ref="SelectScidRef">
                        <Option v-for="item in ScidDataList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                    <!--<Input v-model="FormValidate.S_CID" @on-blur="ScidBlur"  />-->
                </FormItem>
                <FormItem label="户名"  prop="S_HM" v-if="currentPage!='yhfzxz_qy'">
                    <Input v-model="FormValidate.S_HM" disabled="disabled" />
                </FormItem>
                <FormItem label="地址"  prop="S_DZ" v-if="currentPage!='yhfzxz_qy'">
                    <Input v-model="FormValidate.S_DZ" disabled="disabled" />
                </FormItem>
                <FormItem label="用水性质"  prop="WaterNature" v-show="currentPage=='ysxz_qy'&&currentPage!='yhfzxz_qy'">
                    <Input v-model="FormValidate.WaterNature" disabled="disabled" />
                </FormItem>
                <FormItem label="水价"  prop="WaterPrice" v-show="currentPage=='ysxz_qy'||currentPage!='yhfzxz_qy'">
                    <Input v-model="FormValidate.WaterPrice" disabled="disabled" />
                </FormItem>
                <FormItem label="欠费"  prop="WaterArrears" v-if="currentPage!='yhfzxz_qy'">
                    <Input v-model="FormValidate.WaterArrears" disabled="disabled" />
                </FormItem>

                <div v-for="(item,index) in CurrentViewArr" :key="'upload'+index">
                    <FormItem :label="item.value"  :prop="item.prop">
                        <Input v-model="FormValidate[item.prop]"
                               v-if="item.type=='input'" type="text"
                               :disabled="FormValidate.BtnName=='提交'||
                                (currentPage=='zxsq_qy'&&FormValidate.SelectList.CancellationContent.CurrentKey!='3')&&item.prop=='OtherContent'||
                                (currentPage=='yhfzxz_qy'&&FormValidate.SelectList.S_YongTu.CurrentKey!=5)&&item.prop=='S_YongTuSM'" />
                        <Input v-model="FormValidate[item.prop]" v-else-if="item.type=='textarea'" type="textarea" :autosize="true" :disabled="FormValidate.BtnName=='提交'" />
                        <RadioGroup v-model="FormValidate.SelectList[item.prop].CurrentKey" v-else-if="item.type=='radio'" :disabled="FormValidate.BtnName=='提交'">
                            <Radio :label="n.value" v-for="(n,i) in FormValidate.SelectList[item.prop].List" :key="i" :disabled="FormValidate.BtnName=='提交'"><span>{{ n.label }}</span></Radio>
                        </RadioGroup>
                        <Select v-model="FormValidate.SelectList[item.prop].CurrentKey"  v-else-if="item.type=='select'" :disabled="FormValidate.BtnName=='提交'">
                            <Option v-for="(p,o) in FormValidate.SelectList[item.prop].List" :value="p.value" :key="o">{{ p.label }}</Option>
                        </Select>
                        <DatePicker v-model="FormValidate[item.prop]" type="date" v-else-if="item.type=='date'" style="width:100%" :disabled="FormValidate.BtnName=='提交'"></DatePicker>
                        <Cascader :data="FormValidate.Cascader.List"
                                  v-model="FormValidate.Cascader[item.prop]"
                                  v-else-if="item.type=='timeperiod'"
                                  style="width:100%"
                                  @on-visible-change="GetCascaderData"
                                  :disabled="FormValidate.BtnName=='提交'"></Cascader>

                        <div v-else-if="item.type=='file'">
                            <UploadImg :MaxSize="item.size"
                                       :MaxLength="item.maxLength"
                                       :Prop="item.prop"
                                       :Value="item.value"
                                       :FormatType="['jpg','jpeg','png']"
                                       :isValid="item.isValid"
                                       :ref="item.prop"
                                       @fatherImage="fatherImage"
                                       @loadingSpin="loadingSpin"
                            ></UploadImg>
                            <div v-if="item.Type==2||item.Type==1">
                                    <Button type="primary" 
                                    style="width:160px;background-color: #E4F2FF!important;border-color: #E4F2FF!important;color:#0F71B3"
                                    @click="Certification(item.Type)">获取{{item.value}}照</Button>
                                </div>
                            <div v-else-if="ZWWToken"><Button type="primary" @click="Certification(item.Type)" style="width:160px;background-color: #E4F2FF!important;border-color: #E4F2FF!important;color:#0F71B3">获取{{item.value}}</Button></div>
                        </div>
                    </FormItem>

                </div>
               <!--生成申请单后要继续操作，下载和提交申请单-->
                <div v-if="FormValidate.BtnName=='提交'">
                    <div v-for="(item,index) in ButtonDownArr" :key="'item'+index">
                        <FormItem :label="'下载'+item.name">
                            <a :href='DomainApi+item.url' target="_blank">点此下载</a>
                        </FormItem>
                    </div>

                    <div v-for="(item_dzq,index_dzq) in DianZiQianArr" :key="'dzq'+index_dzq">
                        <FormItem :label="'签订'+item_dzq.name">
                            <a :href='item_dzq.url' target="_blank">点此签订</a>
                        </FormItem>
                    </div>
                    <div v-for="(item,index) in UploadViewArr" :key="index" >
                        <FormItem :label="item.value"  :prop="item.prop">
                            <div v-if="item.type=='file'">
                                <UploadImg :MaxSize="item.size"
                                           :MaxLength="item.maxLength"
                                           :Prop="item.prop"
                                           :Value="item.value"
                                           :FormatType="['jpg','jpeg','png']"
                                           :isValid="item.isValid"
                                           :ref="item.prop"
                                           @fatherImage="fatherImage"
                                           @loadingSpin="loadingSpin"
                                ></UploadImg>
                            </div>
                        </FormItem>
                    </div>
                    <p v-show="currentPage=='sbjy_qy'&&JFPZCnt==0&&FormValidate.BtnName=='提交'" style="margin:10px 0 10px 20px;">注：水表检验需要预收取100元的费用，请打款至以下银行账户后提供缴费凭证的图片进行上传：银行名称：中国建设银行苏州新区支行。银行账户：32201988636050852397</p>
                </div>


                <FormItem class="businessFormBtn" v-show="FormValidate.BtnName=='提交'&&UploadViewArr.length>0||FormValidate.BtnName=='生成申请单'">
                    <Button type="primary" @click="SubmitAll('FormValidate')"  style="width:160px;">{{FormValidate.BtnName}}</Button>
                </FormItem>
            </Form>
           <!--二维码显示-->
          <Modal v-model="qrcode" footer-hide title="" @on-visible-change="clearTimer">
            <div>
                <div style="height:240px;margin-top: 2rem;text-align: center;">
                    <img :src="QRcode">
                </div>
                <div style="text-align: center;">
                    <p style="margin-top:5px;font-size: 16px;">{{erweimaTxt}}</p>
                </div> 
            </div>
        </Modal>
        <!--房产证列表显示-->
         <Modal v-model="FaChangZhengList" footer-hide title="房产证列表">
             <Table :columns="FormImage.ColumnsValue" :data="FormImage.FormData" size="small" style="padding-top: 1rem;height:96%"></Table>
         </Modal>
         <!--房产证列表预览-->
         <Modal title="预览" v-model="Visible" width="720" height="650">
            <img :src="ImgURL"  v-if="Visible" style="width:100%;">
            <div slot="footer">
                 <Button type="text" @click="Visible=false">取消</Button>
                 <Button type="primary" @click="SetImgData">确定</Button>
            </div>
        </Modal>
        </div>
        <Spin size="large" fix v-if="SpinShow"></Spin>
    </div>
</template>

<script>
    import {Format} from '@/js/formatDate.js';
    import SelectRole from './SelectRole';
    import UploadImg from '../Other/UploadImg';
    import { Divider,Cascader } from 'view-design';
    import { domain } from '@/api/apiConfig.js'
    export default {
        name: 'BusinessForm_DW',
        props:["currentPage"],
        components:{
            SelectRole,
            UploadImg,
            Divider,
            Cascader
        },
        data(e) {
            return {
                FZCLCnt: 0,
                JFPZCnt: 0,
                DomainApi:domain.InApi,
                CurrentPageTitle:'',//当前页面标题
                CurrentViewArr:[],//当前页面数组
                UploadViewArr:[],//当前页面提交申请单后显示的申请单内容
                ButtonDownArr:[],//当前页面提交申请单后的可下载单据
                DianZiQianArr:[],//可以电子签的单据
                I_Type:0,//当前页面类型提交
                FormValidate: {
                    S_HM:"",
                    S_DZ:"",
                    S_CID:"",
                    WaterNature:"",
                    WaterArrears:"",
                    BZ:"",
                    WaterPrice:"",
                    Pattern:"",
                    S_CIDList:[],
                    SelectList: {
                        InvoiceType: {CurrentKey: '',List: []},
                        S_JiaoFenFS:{CurrentKey:'',List:[]},
                        TransferReason:{CurrentKey:'',List:[]},
                        CancellationContent:{CurrentKey:'1',List:[{label:"基建拆表",value:"1"},{label:"拆迁拆表",value:"2"},{label:"其它",value:"3"}]},
                        IsYouJi:{CurrentKey:0,List:[{label:'是',value:1},{label:'否',value:0}]},//0不需要邮寄 1需要邮寄
                        S_YeWuLX:{CurrentKey:'',List:[]},//{label:"单位或个人接用水",value:"1"},
                        S_YongTu:{CurrentKey:'',List:[]}
                    },
                    Cascader:{
                        ScheduledDate:[],
                        List:[{value: '',label: '',children: []}]
                    },
                    TransferReason:"",
                    OriginalUser:"",
                    OriginalUserPhone:"",
                    Reason:"",//注销原因
                    Requisition:[],//申请单
                    CollectionAgreement:[],//托收协议
                    PaymentVoucher:[],//缴费凭证
                    LetterOfAuthorization:[],//授权委托书
                    CustomerInfo:[],//客户信息采集表
                    Property:[],//产权证
                    S_YingYeZZ:[],
                    S_ShenFenZheng:[],
                    BtnName:"",
                    GMF_NSRSBH:"",
                    GMF_DZ:"",
                    GMF_DH:"",
                    GMF_YH:"",
                    GMF_ZH:"",
                    ExistingProblems:"",//存在问题
                    ExpectedDate:"",//希望时间
                    S_BiaoWuDiH:"",//表务电话
                    WT_JFPZ: [], // 缴费凭证
                    WT_Others: [], //申请辅助材料
                    ReceiveName:"",
                    ReceivePhoneNum:"",
                    ReceiveAdd:"",
                    ReceiveZip:""
                },
                RuleValidate: {
                    S_CID: [{ required: true,trigger: 'change',validator:(rule, value, callBack)=>{
                            if (!value) { return callBack('客户编号不能为空');}
                            else {return callBack();}
                        }
                    }],
                    Pattern:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.Pattern){return callback(); }
                            else{return callback(new Error("复接类型不能为空"));}
                        } }],
                    Reason:[{ required: true, message: '申请原因不能为空', trigger: 'blur' }],
                    InvoiceType:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.SelectList.InvoiceType.CurrentKey){return callback(); }
                            else{return callback(new Error("发票类型不能为空"));}
                        } }],
                    GMF_NSRSBH: [{ required: true, message: '纳税人识别号不能为空', trigger: 'blur' }],
                    GMF_DZ: [{ required: true, message: '公司地址不能为空', trigger: 'blur' }],
                    GMF_DH: [{ required: true, message: '公司电话不能为空', trigger: 'blur' }],
                    GMF_YH: [{ required: true, message: '开户银行名称不能为空', trigger: 'blur' }],
                    GMF_ZH: [{ required: true, message: '开户银行账号不能为空', trigger: 'blur' }],
                    S_JiaoFenFS:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.SelectList.S_JiaoFenFS.CurrentKey=='1'){
                                if(e.CurrentViewArr.length<=11){
                                    e.CurrentViewArr.push({ value: "发票是否需要邮寄", isValid: false, type: "select", prop: "IsYouJi" });
                                    e.FormValidate.SelectList.IsYouJi.CurrentKey=0;
                                }
                                return callback();
                            }else if(e.FormValidate.SelectList.S_JiaoFenFS.CurrentKey=='0'){
                                e.CurrentViewArr.splice(10,5);
                                e.FormValidate.CurrentKey=0;
                                return callback();
                            }
                            else{return callback(new Error("缴费方式不能为空"));}
                        } }],
                    TransferReason:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.SelectList.TransferReason.CurrentKey){return callback(); }
                            else{return callback(new Error("过户原因不能为空"));}
                        } }],
                    OriginalUser: [{ required: true, message: '原用户联系人不能为空', trigger: 'blur' }],
                    OriginalUserPhone: [{ required: true, trigger: 'blur',validator:function(rule, value, callback){
                            if(!value){return callback(new Error("原用户联系电话不能为空"));}
                            else if(!/^[0-9]*$/.test(value)){return callback(new Error("原用户联系电话必须为数字"))}
                            else{ return callback();}
                        } }],
                    CancellationContent:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                        let _cancelContent=e.FormValidate.SelectList.CancellationContent.CurrentKey;
                            if(_cancelContent&&_cancelContent=='3'){
                                e.RuleValidate.OtherContent[0].required=true;
                                e.RuleValidate.ScheduledDate[0].message="希望完成日期不能为空";
                                e.CurrentViewArr[3].value="希望完成日期";
                                return callback();}
                            else if(_cancelContent&&_cancelContent!='其它'){ e.RuleValidate.OtherContent[0].required=false;return callback();}
                            else{return callback(new Error("注销内容不能为空"));}
                        } }],
                    OtherContent: [{ required: false, message: '其它原因不能为空', trigger: 'blur' }],
                    CancellationReason: [{ required: true, message: '注销原因不能为空', trigger: 'blur' }],
                    ExpectedDate: [{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(value){return callback(); }
                            else{return callback(new Error("希望拆表日期不能为空"));}
                        } }],
                    ScheduledDate:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            let _ScheduledDate=e.FormValidate.Cascader.ScheduledDate;
                            if(_ScheduledDate.length>0){return callback();}
                            else{return callback(new Error("预约时间不能为空"));}
                        } }],
                    ExistingProblems:[{ required: true, message: '存在问题不能为空', trigger: 'blur' }],
                    IsYouJi:[{ required: false, trigger: 'change',validator: function(rule, value, callback){
                            if(e.currentPage=='ghsq_qy'&&e.FormValidate.SelectList.IsYouJi.CurrentKey==0){
                                e.CurrentViewArr.splice(11,4);
                                return callback();
                            }else if(e.currentPage=='shtd_qy'&&e.FormValidate.SelectList.IsYouJi.CurrentKey==0){
                                e.CurrentViewArr.splice(9,4);
                                return callback();
                            }else if(e.FormValidate.SelectList.IsYouJi.CurrentKey==1){
                                if(e.currentPage=='ghsq_qy'&&e.CurrentViewArr.length<=11){
                                    e.CurrentViewArr.push({ value: "收件人姓名", isValid: false, type: "input", prop: "ReceiveName" },
                                        { value: "收件人电话", isValid: false, type: "input", prop: "ReceivePhoneNum" },
                                        { value: "发票邮寄地址", isValid: false, type: "input", prop: "ReceiveAdd" },
                                        { value: "邮政编码", isValid: true, type: "input", prop: "ReceiveZip"});
                                }else if(e.currentPage=='shtd_qy'&&e.CurrentViewArr.length<=9){
                                    e.CurrentViewArr.push({ value: "收件人姓名", isValid: false, type: "input", prop: "ReceiveName" },
                                        { value: "收件人电话", isValid: false, type: "input", prop: "ReceivePhoneNum" },
                                        { value: "发票邮寄地址", isValid: false, type: "input", prop: "ReceiveAdd" },
                                        { value: "邮政编码", isValid: true, type: "input", prop: "ReceiveZip"});
                                }
                                return callback();
                            }
                            else{return callback(new Error("是否邮寄不能为空"));}
                        } }],
                    ReceiveName:[{ required: false, trigger: 'blur',validator: function(rule, value, callback){
                            if(e.currentPage=='ghsq_qy'&&e.FormValidate.SelectList.IsYouJi.CurrentKey==1&&e.CurrentViewArr.length>11&&value){return callback();}
                            else if(e.currentPage=='shtd_qy'&&e.FormValidate.SelectList.IsYouJi.CurrentKey==1&&e.CurrentViewArr.length>8&&value){return callback();}
                            else{return callback(new Error("收件人姓名不能为空"));}
                        } }],
                    ReceivePhoneNum:[{ required: false, trigger: 'blur',validator: function(rule, value, callback){
                            if(e.currentPage=='ghsq_qy'&&e.FormValidate.SelectList.IsYouJi.CurrentKey==1&&e.CurrentViewArr.length>11&&value){return callback();}
                            else if(e.currentPage=='shtd_qy'&&e.FormValidate.SelectList.IsYouJi.CurrentKey==1&&e.CurrentViewArr.length>8&&value){return callback();}
                            else{return callback(new Error("收件人电话不能为空"));}
                        } }],
                    ReceiveAdd:[{ required: false, trigger: 'blur',validator: function(rule, value, callback){
                            if(e.currentPage=='ghsq_qy'&&e.FormValidate.SelectList.IsYouJi.CurrentKey==1&&e.CurrentViewArr.length>11&&value){return callback();}
                            else if(e.currentPage=='shtd_qy'&&e.FormValidate.SelectList.IsYouJi.CurrentKey==1&&e.CurrentViewArr.length>8&&value){return callback();}
                            else{return callback(new Error("发票邮寄地址不能为空"));}
                        } }],
                    ReceiveZip:[{ required: false, trigger: 'blur',validator: function(rule, value, callback){
                            if(e.currentPage=='ghsq_qy'&&e.FormValidate.SelectList.IsYouJi.CurrentKey==1&&e.CurrentViewArr.length>11&&value){return callback();}
                            else if(e.currentPage=='shtd_qy'&&e.FormValidate.SelectList.IsYouJi.CurrentKey==1&&e.CurrentViewArr.length>8&&value){return callback();}
                            else{return callback(new Error("邮政编码不能为空"));}
                        } }],
                    S_BiaoWuDiH:[{ required: true, trigger: 'blur',validator: function(rule, value, callback){
                            let reg = /^1[3456789]\d{9}$/;
                            if (value == '') {return callback('表务电话不能为空');}
                            else if (!reg.test(value)) {return callback('表务电话必须为手机号');}
                            else {return callback();}
                        }}],
                    WT_JFPZ:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.WT_JFPZ.length>0){return callback(); }
                            else{return callback(new Error("请上传缴费凭证"));}
                        }}],
                    S_YeWuLX:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.SelectList.S_YeWuLX.CurrentKey){return callback(); }
                            else{return callback(new Error("业务类型不能为空"));}
                        } }],
                    S_YongTu:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            let _currentYongTu=e.FormValidate.SelectList.S_YongTu.CurrentKey;
                            if(!_currentYongTu){return callback(new Error("建筑物用途不能为空"));}
                            else if(_currentYongTu&&_currentYongTu!=5){e.RuleValidate.S_YongTuSM[0].required=false;return callback();}
                            else if(_currentYongTu&&_currentYongTu==5){e.RuleValidate.S_YongTuSM[0].required=true;return callback();}
                            else{return callback();}
                        } }],
                    S_YongTuSM: [{ required: false, message: '其它用途说明不能为空', trigger: 'blur' }],
                    D_YongShuiL:[{ required: true,trigger: 'blur',validator: function(rule, value, callback){
                            if(!value){return callback(new Error("用水量不能为空"));}
                            else if(!/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value)){return callback(new Error("用水量只能为正整数"))}
                            else{return callback();}
                        }
                    }],
                    S_XiaoFangQK:[{ required: true,trigger: 'blur',validator:(rule, value, callback)=>{
                            if (!value) { return callback('消防情况不能为空');}
                            else {return callback();}
                        }
                    }],
                    S_BeiZhu:[{ required: true,trigger: 'blur',validator:(rule, value, callback)=>{
                            if (!value) { return callback('备注不能为空');}
                            else {return callback();}
                        }
                    }],
                    S_KeHuDZ:[{ required: true, trigger: 'blur',validator: function(rule, value, callback){
                            if (!value) { return callback('用水地址不能为空');}
                            else {return callback();}
                        } }],
                    S_DWDZ:[{ required: true, trigger: 'blur',validator: function(rule, value, callback){
                            if (!value) { return callback('单位地址不能为空');}
                            else {return callback();}
                        } }],
                    Property:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.Property.length>0){return callback(); }
                            else{return callback(new Error("请上传产权证"));}
                        }
                    }],
                    S_YingYeZZ:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.S_YingYeZZ.length>0){return callback(); }
                            else{return callback(new Error("请上传营业执照"));}
                        }
                    }],
                    S_ShenFenZheng:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.S_ShenFenZheng.length>0){return callback(); }
                            else{return callback(new Error("请上传身份证"));}
                        }
                    }],
                },
                SelectRole: '',
                SpinShow:false,
                Sending:false,
                S_AnJuanID:"",
                DescList:[],//描述
                DescLink:"",//描述文件链接
                 //二维码
                 qrcode:false,
                QRcode:"",
                token:"",
                typeQueryCode:"",
                erweimaTxt:"请用皖事通app扫描认证",
                tokenStatus:false,
                timer:null,
                handleSubNo:"",//身份证
                FaChangZhengList:false,
                FileType:"",
                Visible:false,
                ZWWToken:"",
                ImgURL:"",
                FormImage:{
                    ColumnsValue:[
                        {title: '房产证',key: 'infoCode',align: 'center'},                       
                        // {title: 'id',key: 'id',align: 'center',show:false},
                        // {title: 'token',key: 'token',align: 'center',show:false},
                        // {title: 'format',key: 'format',align: 'center',show:false},                
                        {title: '查看',align: 'center',
                            render: (h, params) => {
                                console.log(params)
                                return   h('p', {
                                    style: {
                                        color:"#1E94EC",
                                        fontSize: "0.8rem",
                                        cursor:"pointer"
                                    },
                                    on: {
                                        click: () => {                                           
                                            this.UploadZhengZhaoOnly(h,params);
                                        }
                                    }
                                }, '查看图片');
                            }
                        },
                    ],
                    FormData:[]
                }
            }
        },
        computed: {
            BaseDataList() {
                return this.$store.state.GetBaseData.BaseData;
            },
            ScidDataList() {
                return this.$store.state.GetScid.S_CIDList;
            }
        },
        created() {
            if(this.BaseDataList&&this.BaseDataList.length<=0){
                this.$store.commit("GetBaseData",2);
            }
            if(this.ScidDataList&&this.ScidDataList.length<=0){
                this.$store.commit("GetScid");
            }
            if(this.currentPage=="yhfzxz_qy"){
                this.JSSQ_GetWords();
            }
        },
        watch: {
            qrcode(newVal){
            if (!newVal) {
                let that = this 
                clearInterval(that.timer);
                that.timer=null;
            }
            }
        },
        beforeDestory(){
            let that = this 
            clearInterval(that.timer);
            that.timer=null;
        },
        mounted() {
            this.ZWWToken=localStorage.getItem("ZWWToken");
            this.InitPage();
        },
        methods: {
            InitPage() {
                switch (this.currentPage) {
                    case "ghsq_qy": //变更过户
                        this.CurrentViewArr = [
                            { value: "过户原因", isValid: true, type: "select", prop: "TransferReason" },
                            { value: "备注", isValid: false, type: "input", prop: "Remark" }
                            // { value: "原用户联系人", isValid: true, type: "input", prop: "OriginalUser" },
                            // { value: "原用户联系电话", isValid: true, type: "input", prop: "OriginalUserPhone" },
                            // { value: "纳税人识别号",isValid: true,type: "input",prop: "GMF_NSRSBH"},
                            // { value: "公司地址", isValid: true, type: "input", prop: "GMF_DZ" },//GMF_DZDH
                            // { value: "公司电话", isValid: true, type: "input", prop: "GMF_DH" },
                            // { value: "开户银行名称", isValid: true, type: "input", prop: "GMF_YH" },//GMF_YHZH
                            // { value: "开户银行账号", isValid: true, type: "input", prop: "GMF_ZH" },
                            // { value: "发票类型", isValid: true, type: "radio", prop: "InvoiceType" },
                            // { value: "收件人姓名", isValid: false, type: "input", prop: "ReceiveName"},
                            // { value: "收件人电话", isValid: false, type: "input", prop: "ReceivePhoneNum"},
                            // { value: "发票邮寄地址", isValid: false, type: "input", prop: "ReceiveAdd"},
                        ];
                        this.I_Type = 9;
                        this.FormValidate.BtnName="生成申请单";
                        this.GetBaseData();
                        this.DescList=[
                            { desc:"1、请准确无误的填写身份认证信息，以便后期业务的开展。"},
                        ];
                        this.DescLink=this.DomainApi+"Resource/DescImg/ghsq_qy.jpg";
                        break;
                    case "zxsq_qy"://注销申请
                        this.CurrentViewArr = [
                            { value: "注销原因", isValid: true, type: "input", prop: "CancellationReason" },
                            { value: "产权证", isValid: true, type: "file", prop: "Property", size: "10", maxLength: '5',Type:"2"},
                            { value: "备注", isValid: false, type: "input", prop: "Remark" }
                        ];
                        this.I_Type = 10;
                        this.FormValidate.BtnName="生成申请单";
                        this.DescList=[                          
                            { desc:"1、上传房产证图片最多不能超过10M"},
                        ];
                        this.DescLink=this.DomainApi+"Resource/DescImg/zxsq_qy.jpg";
                        break;
                    case "yhfzxz_qy"://接水申请
                        this.CurrentViewArr=[
                            {value:"业务类型", isValid: true, type: "select", prop: "S_YeWuLX"},
                            {value:"建筑物用途", isValid: true, type: "select", prop: "S_YongTu"},
                            {value:"其它用途说明", isValid: false, type: "input", prop: "S_YongTuSM"},
                            {value: "用水地址", isValid: true, type: "input", prop: "S_KeHuDZ"},
                            { value: "单位地址", isValid: true, type: "input", prop: "S_DWDZ" },
                            {value: "备注", isValid: false, type: "input", prop: "Remark"},
                            { value: "身份证", isValid: true, type: "file", prop: "S_ShenFenZheng" ,maxLength: '5',Type:"1"},
                            {value: "营业执照", isValid: false, type: "file", prop: "S_YingYeZZ",maxLength: '5',Type:"3"},
                        ];
                        this.DescList=[                          
                            { desc:"1、上传图片最多不能超过10M"},
                        ];
                        this.FormValidate.BtnName="生成申请单";
                        this.I_Type = 18;
                        this.DescLink=this.DomainApi+"Resource/工商业客户用水报装服务指南.jpg";
                        break;
                    default:
                        break;
                }
            },
            GetBaseData(){//获取select中基础数据
                let that=this;
                that.FormValidate.SelectList.S_JiaoFenFS.List=[];
                that.FormValidate.SelectList.InvoiceType.List=[];
                that.FormValidate.SelectList.TransferReason.List=[];
                that.BaseDataList.forEach(function(item){
                    if(item.DicType==10){
                        that.FormValidate.SelectList.S_JiaoFenFS.List.push({label:item.ItemName,value:item.KeyID});
                    }else if(item.DicType==5){
                        if (item.KeyID != 0) {
                            that.FormValidate.SelectList.InvoiceType.List.push({label:item.ItemName,value:item.KeyID});
                        }
                    }
                });
                if(that.currentPage=="ghsq_qy"){
                    that.GetTransferReason();
                }
            },
            JSSQ_GetWords(){
                let that=this;
                that.InApi("api/Flow/Flow/GetWordsValue", {DaLeiKey: "JSSQYeWuLX_qy", XiaoLeiKey: ""},"get").then(function (response) {
                    if(!response)return false;
                    let _data = JSON.parse(response);
                    if (_data.length<=0) {return false;}
                    _data.forEach(function(item){
                        that.FormValidate.SelectList.S_YeWuLX.List.push({label:item.S_XiaoLeiMC,value:item.S_XiaoLeiKey});
                    });
                });
                that.InApi("api/Flow/Flow/GetWordsValue", {DaLeiKey: "JSSQYongTu_qy", XiaoLeiKey: ""},"get").then(function (response) {
                    if(!response)return false;
                    let _data = JSON.parse(response);
                    if (_data.length<=0) {return false;}
                    _data.forEach(function(item){
                        that.FormValidate.SelectList.S_YongTu.List.push({label:item.S_XiaoLeiMC,value:item.S_XiaoLeiKey});
                    });
                });
            },
            GetTransferReason(){
                let that=this;
                that.InApi("api/Flow/Flow/GetWordsValue", {DaLeiKey: "guohuyy", XiaoLeiKey: ""},"get").then(function (response) {
                    if(!response)return false;
                    let _data = JSON.parse(response);
                    if (_data.length<=0) {return false;}
                    that.FormValidate.SelectList.TransferReason.List=[];
                    _data.forEach(function(item){
                        that.FormValidate.SelectList.TransferReason.List.push({label:item.S_XiaoLeiMC,value:item.S_XiaoLeiKey});
                    });
                });
            },
            GetCascaderData(){
                let that=this;
                that.InApi("api/Flow/flow/P_GetYuYueSJ", {},"get").then(function (response) {
                    if(!response)return false;
                    let _data = response;
                    if (_data.length<=0) {return false;}
                    let _casArr=[];
                    _data.forEach(function(item){
                        let _childs=[];
                        (item.childs).forEach(function(qq){
                           _childs.push({value: qq.value,label: qq.value})
                        });
                        _casArr.push({value: item.value,label:item.id,children: _childs});
                    });
                    that.FormValidate.Cascader.List=_casArr;
                });
            },
            ScidBlur(item) {
                item.value!=""&&item.value!=undefined?this.FormValidate.S_CID=item.value:this.FormValidate.S_CID="";
                if(!this.FormValidate.S_CID){return false}
                let that=this;
                that.FormValidate.S_CID=that.FormValidate.S_CID.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
                let _scid=that.FormValidate.S_CID.split("");
                if(_scid.length!=13){
                    that.$Notice.warning({title: '提示',desc: '您输入的客户编号不存在！'});
                    that.$refs['FormValidate'].resetFields();
                    that.$refs.SelectScidRef.query="";
                    return false;
                }
                this.InApi("api/waterbill/waterbill/GetNowMonthBillInfo", { UserNo:this.FormValidate.S_CID },"get").then(function (response) {
                    if(!response)return false;
                    let _data=JSON.parse(response);
                    let jsonData = JSON.parse(_data.DataMain)[0];
                    let waterInfoData = JSON.parse(_data.UserInfo)[0];
                    if (!jsonData) {
                        that.$Notice.warning({title: '提示',desc: '您输入的客户编号不存在！'});
                        that.$refs['FormValidate'].resetFields();
                        that.$refs.SelectScidRef.query="";
                        return false;
                    }
                    /* if (waterInfoData.S_ST == "20") {
                        that.$Notice.warning({title: '提示',desc: '本网厅服务范围仅限马鞍山首创水务供水区域（花山区、雨山区），请知悉！'});
                        return false;
                    } */
                    that.FormValidate.S_HM=waterInfoData.userName;
                    that.FormValidate.S_DZ=waterInfoData.userAddress;
                    that.FormValidate.WaterPrice=waterInfoData.waterPrice;
                    that.FormValidate.WaterNature=waterInfoData.S_JH;
                    that.FormValidate.WaterArrears=jsonData.PayMoney;
                    that.$store.commit("GetScid",{value:item.value,label:item.value});
                    that.FormValidate.S_CID=item.value;
                });
            },
            GetValidCode:function(){
                if(this.Sending) return;
                let _self=this;
                if(_self.FormValidate.PhoneNum=="") {return;}
                if(_self.FormValidate.PhoneNum.split("").length<=10){_self.$Message.error("请输入正确的手机号");return;}
                _self.$refs.btn.run();   //开始倒计时
                _self.Sending=true; //禁用重新发送按钮
                setTimeout(function(){_self.Sending=false}, 60000);
                _self.$store.commit("GetValidCode",_self.FormValidate.PhoneNum);
            },
            SubmitAll(name) {
                let that = this;
                let roleValid=that.$refs.RoleForm.ValidateRole();
                that.$refs[name].validate((valid) => {
                    if (valid) {
                        if(!roleValid){return false;}
                        // 如果已经提交申请单，则直接第二步
                        if(that.FormValidate.BtnName=="提交"){
                            that.UploadRecord(name);
                            return false;
                        }
                        // 如果是新增的单子，则第一步
                        let FlowXX = {
                            HuZhu: that.SelectRole,
                            I_Type: that.I_Type,
                        };

                        let jsonArr = [];
                        let obj = that.FormValidate;
                        Object.keys(obj).forEach(function (key) {
                            if(key!="ButtonDownArr"&&key!="S_CIDList"&&key!="SelectList"&&key!="BtnName"&&key!="WaterPriceShow"&&key!="Cascader"&&key!="ExpectedDate"){//跳过为list和无关btn
                                FlowXX[key]=obj[key];
                            }else if(key=="ExpectedDate"){
                                FlowXX[key]=Format(new Date(obj[key]),'yyyy-MM-dd');
                            }else if(key=="Cascader"){
                                FlowXX["ScheduledDate"]=obj[key].ScheduledDate[0];//["2020-08-27", "15:00-16:00"]
                                FlowXX["ScheduledTime"]=obj[key].ScheduledDate[1];
                            }
                        });
                        let _select=that.FormValidate.SelectList;
                        Object.keys(that.FormValidate.SelectList).forEach(function(item){//select中的obj轮询
                            FlowXX[item]=_select[item].CurrentKey;
                        });
                        console.log(FlowXX);
                        
                        //企业过户和单位资料变更时候，拼一下开票资料
                        if (that.currentPage == "ghsq_qy" || that.currentPage == "shtd_qy") {
                            FlowXX["GMF_DZDH"] = that.FormValidate.GMF_DZ + that.FormValidate.GMF_DH;
                            FlowXX["GMF_YHZH"] =that.FormValidate.GMF_YH + that.FormValidate.GMF_ZH;
                        }
                        if(that.currentPage=="ghsq_qy"){
                            FlowXX["GMF_NSRSBH"]=that.$refs.RoleForm.FormInlineRole.S_OrganCode;
                        }
/*                         if(that.currentPage=="yhfzxz_qy"){
                            let ShenFenZhengString = "";
                            that.FormValidate.S_ShenFenZheng.forEach(function(item){
                                ShenFenZhengString += item.path+",";
                            });
                            ShenFenZhengString = ShenFenZhengString.substring(0,ShenFenZhengString.length-1);
                            let YingYeZZString = "";
                            that.FormValidate.S_YingYeZZ.forEach(function(item){
                                YingYeZZString += item.path+",";
                            });
                            YingYeZZString = YingYeZZString.substring(0,YingYeZZString.length-1);
                            let PicData ={
                                S_YingYeZZ:YingYeZZString,
                                S_ShenFenZheng:ShenFenZhengString
                            }
                        } */
                        const sendObj = Object.assign(FlowXX, jsonArr);
                        //console.log(sendObj);
                        that.SpinShow = true;
                        that.InApi("api/Flow/flow/FlowStart_New", sendObj, "post",).then(response => {
                            if(!response)return false;
                            that.SpinShow = false;
                            let _data = response;
                            if (_data.ReturnCode == false) {
                                that.$Notice.error({title: '提示', desc: _data.ErrorMessage!=""?_data.ErrorMessage:"提交失败"});
                                return false;
                            }
                            
                            that.S_AnJuanID=_data.ReturnMessage;
                            if(_data.I_IsQianFei!=-1){
                                that.FormValidate.BtnName="提交";
                                that.$refs.RoleForm.RoleDisabled=true;
                                //20240325过户、注销直接调用上传协议接口xiaohang
                                if(that.currentPage=="ghsq_qy"||that.currentPage=="zxsq_qy"||that.currentPage=="yhfzxz_qy"){
                                    that.ShangChuanXieYi();
                                }else{
                                    that.$Notice.success({title: '提示', desc: _data.ErrorMessage!=""?_data.ErrorMessage:"提交成功", duration: 0});
                                    that.GetFlowSQD(_data.ReturnMessage);
                                }
                            }else{
                                that.$refs.RoleForm.RoleDisabled=false;
                                that.$refs['FormValidate'].resetFields();
                                that.FormValidate.ReceiveName="";

                                if(that.currentPage=="btsq_qy"||that.currentPage=="sbjy_qy"){
                                    that.FormValidate.Cascader.ScheduledDate=[];
                                }
                            }
                        });
                    }
                });
            },
            GetFlowSQD(AnJuanID){
                let that=this;
                that.InApi("api/Flow/flow/GetFlowSQD", {S_AnJuanID:AnJuanID}, "get",).then(response => {
                    if (!response) return false;
                    that.UploadViewArr=[],that.ButtonDownArr=[],that.DianZiQianArr=[],that.FZCLCnt = 0, that.JFPZCnt = 0;
                    let _jmOrqy = that.S_AnJuanID.split("_");
                    response.forEach(function(item){//I_Type==0下载上传1签订协议
                        if (item.I_QianDingFlag == 0) {
                            if(item.I_Type==0){
                                if (item.S_DocUrl != "") {
                                    that.ButtonDownArr.push({name:  item.TemplateName, url:item.S_DocUrl});
                                }
                                if (_jmOrqy[0]=="jssq"&&_jmOrqy[1] == "qy" && item.S_DocType == "WT_JSYYZZ") {
                                  //20220616小姐姐说如果是企业并且S_DocType == "WT_JSYYZZ"的把营业执照去掉不用上传了xiaohang
                                } else {
                                  that.UploadViewArr.push({value: item.TemplateName, isValid: true, type: "file", prop: item.S_DocType, size: "10", maxLength: '5'});
                                  that.FormValidate[item.S_DocType]=[];
                                  that.RuleValidate[item.S_DocType]=[{required: true, trigger: 'change',validator: function(rule, value, callback){
                                      if(that.FormValidate[item.S_DocType].length>0){return callback(); }
                                      else{return callback(new Error("请上传"+item.TemplateName));}
                                    }
                                  }];
                                }
                            }else{
                                if (item.S_DocUrl != "") {
                                    that.DianZiQianArr.push({name: item.TemplateName, url:item.S_DocUrl});
                                } else {
                                    if (_jmOrqy[0]=="jssq"&&_jmOrqy[1] == "qy" && item.S_DocType == "WT_JSYYZZ") {
                                      //20220616小姐姐说如果是企业并且S_DocType == "WT_JSYYZZ"的把营业执照去掉不用上传了xiaohang
                                    } else {
                                      that.UploadViewArr.push({value: item.TemplateName, isValid: true, type: "file", prop: item.S_DocType, size: "10", maxLength: '5'});
                                      that.FormValidate[item.S_DocType]=[];
                                      that.RuleValidate[item.S_DocType]=[{required: true, trigger: 'change',validator: function(rule, value, callback){
                                          if(that.FormValidate[item.S_DocType].length>0){return callback(); }
                                          else{return callback(new Error("请上传"+item.TemplateName));}
                                        }
                                      }];
                                    }
                                }
                            }
                        } else if (item.I_QianDingFlag == 1&&item.S_DocType == "WT_JFPZ"){
                            that.JFPZCnt = that.JFPZCnt + 1;
                        }
                    });
                    // if (that.FZCLCnt == 0) {
                    //     that.UploadViewArr.push({ value: "申请辅助材料", isValid: false, type: "file", prop: "WT_Others", size: "10", maxLength: '5' });
                    // }
                });
            },
            UploadRecord(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let that=this;
                        let jsonArr={};
                        that.UploadViewArr.forEach(function(item){
                            if(item.type=="file"){
                                let _key=item.prop;
                                let ResUploadUrl=[];
                                that.FormValidate[_key].forEach(function(item){
                                    ResUploadUrl.push(item)
                                });
                                jsonArr[_key]=ResUploadUrl;
                            }
                        });
                        let FlowXX={
                            S_FlowFlag:"申请审核",
                            S_NodeID: "lcfq",
                            S_RenWuID:that.S_AnJuanID,
                            WangTingOrLeaRun:""
                        };
                        let sendObj = Object.assign(FlowXX,jsonArr);
                        console.log(sendObj);
                        // 判断是否是报停
                        if(that.currentPage=="btsq_qy"){
                            that.$Modal.confirm({
                                title: "提醒",
                                okText: "确认提交",
                                content: "尊敬的用户：报停如果超过3个月，请到柜台或者网上营业厅重新办理接水申请",
                                onOk: () => {
                                    that.SpinShow=true;
                                    that.InApi("api/Flow/flow/ShangChuanXieYi", sendObj, "post",).then(response => {
                                        if(!response)return false;
                                        that.SpinShow=false;
                                        let _data = response;
                                        if(_data.ReturnCode==false) {
                                            that.$Notice.error({title: '提示', desc: _data.ErrorMessage!=""?_data.ErrorMessage:"提交失败"});
                                            return false;
                                        }
                                        let _ReturnMessage = (_data.ErrorMessage == "" || _data.ErrorMessage == null) ? "提交成功" : _data.ErrorMessage;
                                        that.$Notice.success({title: '提示', desc: _ReturnMessage, duration: 0});
                                        that.FormValidate.BtnName="生成申请单";
                                        that.$refs.RoleForm.RoleDisabled=false;
                                        that.$refs['FormValidate'].resetFields();
                                        that.CurrentViewArr.forEach(function(item){
                                            if(item.type=="file"){
                                                let _prop=item.prop;
                                                that.$refs[_prop][0].Reset();//清空图片
                                            }
                                        });
                                    });
                                }
                            });
                        }else{
                            that.SpinShow=true;
                            that.InApi("api/Flow/flow/ShangChuanXieYi", sendObj, "post",).then(response => {
                                if(!response)return false;
                                that.SpinShow=false;
                                let _data = response;
                                if(_data.ReturnCode==false) {
                                    that.$Notice.error({title:'提示',desc: _data.ReturnMessage});
                                    return false;
                                }
                                let _ReturnMessage = (_data.ErrorMessage == "" || _data.ErrorMessage == null) ? "提交成功" : _data.ErrorMessage;
                                that.$Notice.success({title: '提示', desc: _ReturnMessage, duration: 0});
                                that.FormValidate.BtnName="生成申请单";
                                that.$refs.RoleForm.RoleDisabled=false;
                                that.$refs['FormValidate'].resetFields();
                                that.CurrentViewArr.forEach(function(item){
                                    if(item.type=="file"){
                                        let _prop=item.prop;
                                        that.$refs[_prop][0].Reset();//清空图片
                                    }
                                });
                            });
                        }
                    }
                });
            },
            CurrentRoleData(item) {
                this.SelectRole = item;
            },
            fatherImage(file){
                this.FormValidate[file.prop]=file.length>0?file:[];
            },
            loadingSpin(status){
                this.SpinShow=status;
            },
            Certification(type){
                 //获取到二维码
                 if(type=="2"){
                     this.TokenStatus(type)
                 }else{                    
                     this.TokenStatus(type)
                 }                                                       
            },
            TokenStatus(BtnType){
                let that = this;
                // if(that.token==""){
                //     that.timer=setInterval(that.GetTokenStatus,5000,["1",BtnType]);
                //     that.RestReqAuthOnline(BtnType);
                //     //that.qrcode = true;
                //     //轮询获取扫描二维码的的认证状态
                    
                // }else{
                //     that.GetTokenStatus(["2",BtnType]);
                // }
              that.timer=setInterval(that.GetTokenStatus,5000,["1",BtnType]);
              that.RestReqAuthOnline(BtnType);

            },
            //获取token 二维码
            RestReqAuthOnline(BtnType){
                let that = this;
                let ThirdID ="";
                ThirdID = that.SelectRole;
                if(!ThirdID){
                  that.$nextTick(()=>{
                    that.qrcode = false;
                  });
                  that.$Notice.error({title: '提示', desc: "请先选择用户"});
                  clearInterval(that.timer);
                  that.timer = null;
                  return false;
                } 
                 /* let typeCode="";
                 if(that.currentPage=="zxsq_qy"){
                     typeCode ="2"
                 }else if(that.currentPage=="zxsq_qy"){

                 } */
                let data = {
/*                  handleSubName:"",
                    handleSubNo:"",
                    S_ThirdID:ThirdID,
                    handleBusiness:"办理业务",       
                    typeCode: 1,//类型 1身份证 2营业执照 3房产证
                    dataUseRange: "1,2,3", //数据使用范围1：证照材料信息，2：证照材料文件，3：证照照面信息
                    handleType: "1",//办理类型：1：自办，2：代办
                    useTerminal: "1",//使用终端：1：PC，2:APP
                    loginToken: "",//用户登录token（代办时必填）
                    agencySubName: "",//代办主体名称（代办时必填）
                    agencySubNo: "",//代办主体代码（代办时必填）
                    queryType: "1",//默认1：优先使用电子证照，无证照查询材料；2：仅使用电子证照；3：仅使用电子材料 */
                     typeCode: BtnType,//类型 1身份证 2房产证3营业执照
                     S_ThirdID:ThirdID,
                     loginToken:that.ZWWToken,
                     useTerminal:"1",
                     handleType:BtnType=="3"?"2":"1"
                }
                that.SpinShow=true;
                that.InApi("api/WanShiTong/ShuiWuTong/RestReqAuthOnline",data,"post").then(result => {
                    that.SpinShow=false;
                    if(!result) return false;
                    let _data = result;
                    if(_data.returnCode==false) {
                        that.$Notice.error({title: '提示', desc:_data.returnMessage||"未获取到对应类型的证照或材料"});
                        clearInterval(that.timer);
                        that.timer = null;
                        return false;
                    }
                    let returnData = JSON.parse(_data.returnData)
                    that.QRcode ='data:image/png;base64,'+ returnData.qrCode
                    that.token = returnData.token
                    that.typeQueryCode = returnData.typeQueryCode;
                    that.qrcode = true;
                    //that.$refs['FormInline'].resetFields();
                }) 
            },
            //获取认证状态
            GetTokenStatus([type,BtnType]){
                let CurrentType = BtnType;
                let that = this;
                let data = {
                    loginToken : that.token,
                    token : that.token
                }
                that.InApi("api/WanShiTong/ShuiWuTong/RestReqTokenStatus",data,"post").then(result => {
                    that.SpinShow=false;
                    if(!result) return false;
                    let _data = result;
                    if(_data.returnCode==false) {
                       if(type=="2"){
                        that.RestReqAuthOnline(CurrentType);
                        that.qrcode = true;
                        //轮询获取扫描二维码的的认证状态
                        console.log(type,BtnType)
                        that.timer=setInterval(that.GetTokenStatus,5000,["1",BtnType]);
                       }
                        return false;
                    }
                    let returnData = JSON.parse(_data.returnData)
                    let handleSubName = returnData.handleSubName;
                    that.handleSubNo = returnData.handleSubNo;
                    console.log(handleSubName,that.handleSubNo)
                    //that.erweimaTxt="认证成功"
                    console.log(that.timer) 
                    clearInterval(that.timer);
                    that.timer = null;
                    that.UploadZhengZhao(CurrentType);
                    that.qrcode = false;
                    that.tokenStatus=true;                                                      
                })                    
            },
            //获取证件照
            UploadZhengZhao(BtnType){
                 let that = this;
                 let data = {
                     token:that.token,
                     typeCode:BtnType,
                     //subNo:that.handleSubNo,
                     typeQueryCode:that.typeQueryCode
                 }
                 console.log(data)
                 
                  that.InApi("api/WanShiTong/ShuiWuTong/UploadZhengZhao",data,"post").then(result => {
                    that.SpinShow=false;
                      if(!result) return false;
                      let _data = result;
                      if(_data.returnCode==false) {
                         that.$Notice.error({title: '提示', desc: _data.returnMessage});
                         return false;
                      } 
                      if(_data.returnData==""){
                         that.$Notice.error({title: '提示', desc: "您没有证件照"});
                         return false;
                      }
                      console.log(JSON.parse(_data.returnData))                                          
                      let _responseFile={fileId:that.Prop,
                          fileName:that.Value,
                          path:JSON.parse(_data.returnData).FileUrl
                      } 
                     if(BtnType=="1"){
                         let returnDataFileUrl = JSON.parse(_data.returnData).FileUrl
                         console.log(returnDataFileUrl);
                        //  console.log(that.$refs.HuZhuIDCard[0].ImgList);
                         _responseFile={
                             fileId:"HuZhuIDCard",
                             fileName:"身份证件号",
                             path:returnDataFileUrl[0]
                        } 
                         that.$refs.S_ShenFenZheng[0].ImgList.push(_responseFile);
                         that.$refs.S_ShenFenZheng[0].ImgList["prop"]="HuZhuIDCard";
                         that.FormValidate.S_ShenFenZheng.push(_responseFile);
                        clearInterval(that.timer);
                        that.timer = null;
                     }
                      //房产证打开弹层显示列表
                      if(BtnType=="2"){
                          let returnDataFileUrl = JSON.parse(_data.returnData).FilePL
                          if (returnDataFileUrl==null) {
                              that.$Notice.error({title: '提示', desc: "您没有产权证"});
                              return false;
                          }                          
                          console.log(returnDataFileUrl);
                          that.FormImage.FormData = returnDataFileUrl;
                          that.FileType=JSON.parse(_data.returnData).FileType;
                          that.FaChangZhengList=true;
                          clearInterval(that.timer);
                          that.timer = null;
                      }
                      //S_YingYeZZ营业执照
                       if(BtnType=="3"){
                          let returnDataFileUrl = JSON.parse(_data.returnData).FileUrl
                          if (returnDataFileUrl==null) {
                              that.$Notice.error({title: '提示', desc: "您没有营业执照"});
                              return false;
                          }
                          let _responseFile={
                              fileId:"S_YingYeZZ",
                              fileName:"营业执照",
                              path:returnDataFileUrl[0]
                          } 
                          that.$refs.S_YingYeZZ[0].ImgList.push(_responseFile)
                          that.$refs.S_YingYeZZ[0].ImgList["prop"]="S_YingYeZZ";
                          that.FormValidate.S_YingYeZZ.push(_responseFile)       
                          clearInterval(that.timer);
                          that.timer = null;
                      }
                  })
            },
             //下载房产证
             UploadZhengZhaoOnly(h,params){
                let that = this;
                let paramsData =params.row
                let data ={
                    token:paramsData.token,
                    id:paramsData.id,
                    format:paramsData.format,
                    typeCode:that.FileType
                }
                
                that.InApi("api/WanShiTong/ShuiWuTong/UploadZhengZhaoOnly",data,"post").then(result => {
                    that.SpinShow=false;
                      if(!result) return false;
                      let _data = result;
                      if(_data.returnCode==false) {
                         that.$Notice.error({title: '提示', desc: _data.returnMessage});
                         return false;
                      }
                      if(_data.returnData==""){
                         that.$Notice.error({title: '提示', desc:"未获取到证照"});
                         return false;
                      }else{
                        let returnDataFileUrl = JSON.parse(_data.returnData).FileUrl;
                       console.log(returnDataFileUrl);
                       that.Visible=true;
                       that.ImgURL =  that.DomainApi+returnDataFileUrl[0];
                      }
                      
                })
            },
            SetImgData(){
                let _path = this.ImgURL.split("Resource");
                console.log(_path);
                let _responseFile ={
                    fileId: "Property",
                    fileName:"产权证",
                    path:"Resource"+_path[1]
                }
                // this.$refs.Property[0].ImgList.push(_responseFile);
                this.$refs.Property[0].ImgList["prop"]="Property";
                this.FormValidate.Property.push(_responseFile)
                this.FaChangZhengList=false;
                this.Visible=false;
            },
            clearTimer(type){
                let that = this;
                if(type==false){
                    console.log("false")
                    clearInterval(that.timer);
                    that.timer=null;
                }
            },
            ShangChuanXieYi(){
                let that = this;
                let jsonArr = {};
                let FlowXX={
                    S_FlowFlag:"申请审核",
                    S_NodeID: "lcfq",
                    S_RenWuID:that.S_AnJuanID,
                    WangTingOrLeaRun:""
                };
                let sendObj = Object.assign(FlowXX,jsonArr);
                //console.log(sendObj);
                that.SpinShow=true;
                that.InApi("api/Flow/flow/ShangChuanXieYi", sendObj, "post",).then(response => {
                    if(!response)return false;
                    that.SpinShow=false;
                    let _data = response;
                    if(_data.ReturnCode==false) {
                        that.$Notice.error({title:'提示',desc: _data.ReturnMessage});
                        return false;
                    }
                    let _ReturnMessage = (_data.ErrorMessage == "" || _data.ErrorMessage == null) ? "提交成功" : _data.ErrorMessage;
                    that.$Notice.success({title: '提示', desc: _ReturnMessage, duration: 0});
                    that.FormValidate.BtnName="生成申请单";
                    that.$refs.RoleForm.RoleDisabled=false;
                    that.$refs['FormValidate'].resetFields();
                    that.CurrentViewArr.forEach(function(item){
                        if(item.type=="file"){
                            let _prop=item.prop;
                            that.$refs[_prop][0].Reset();//清空图片
                        }
                    });
                });
            }
        }
        
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3{
        font-size: 14px;
    }
    .ivu-row{
        margin-left: 16px!important;
        margin-right: 16px!important;
    }
    .txtClass h3{
        padding:10px 0
    }
    .contentArea .iconBlock{
        width:8px;
        height:20px;
        background:#f90;
        position: absolute;
        top:20px;
        left:0
    }
    .contentArea h3{
        text-align: left;
        font-size:18px;
    }
    .txtClass .iconBlock{
        width:8px;
        height:20px;
        background:#2EB4E9;
        position: absolute;
        top:10px;
        left:0
    }
    .submitBtn{
        padding-top:10px;
    }
    .formArea{
        padding-top:30px;
    }
    .ivu-form-item{
        text-align: left!important;
    }
    /*上传图片*/
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

    .explainTXT{
        text-align: left
    }
    .explainTXT p{
        line-height:32px;
    }

</style>
